import { fetchSessions } from '@/services/sessions'
import type { ApiResponse, Session } from '@/types/global'
import { useQuery } from '@tanstack/vue-query'

export const allSessions = (select = (data: Session[]) => data, fields?: string[]) =>
  useQuery({
    queryKey: ['all-sessions', fields],
    queryFn: async () => await fetchSessions(fields),
    select
  })
